export default __webpack_public_path__ + "static/media/3 CG.91cc506b.png";